<template>
  <header class="header__container">
    <Header/>
  </header>
  <main>
    <slot/>
  </main>
  <section id="form" class="form__container scroll-anchor">
    <FormSection/>
  </section>
  <footer class="footer__container">
    <Footer/>
  </footer>
</template>
